import { observer } from 'mobx-react-lite';
import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { IcBackIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IconButton, Link } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import Tasks from 'APP/Tasks';
import { UnauthorizedLayout } from 'APP/components/UnauthorizedLayout/UnauthorizedLayout';
import { RouterLink } from 'APP/router/constants';

import styles from './BlockedView.styles.m.css';

export const BlockedView: FC = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const onBack = useCallback(async () => {
    await Tasks.authorization.logout(true);
    navigate(RouterLink.Login, { replace: true });
  }, []);

  return (
    <UnauthorizedLayout mainWrapperClassName={styles.container}>
      <div className={styles.content}>
        <IconButton
          Icon={IcBackIcon}
          onClick={onBack}
          className={styles.buttonBack}
        />
        <img
          src={getMascotImageSrc('ic-secure-error.png')}
          className={styles.logo}
          alt={''}
        />
        <div className={styles.title}>{t('trusted_device_blocked_title')}</div>
        <div className={styles.subtitle}>
          {t('trusted_device_blocked_restore_access')}
          &nbsp;
          <Link
            color="primary"
            underline={false}
            onClick={(): void => {
              Tasks.app.openSupport();
            }}
          >
            {t('common_contact_support')}
          </Link>
        </div>
      </div>
    </UnauthorizedLayout>
  );
});
